/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { getProductData } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { ExtraContent } from "@/src/services/litigationCase/StatusBox/ExtraContent";
import { getButton, getContent, getPercentage } from "@/src/services/litigationCase/statusBoxSteps";

export const getStatusBoxConfigGeneralCivilLaw = (generalCivilLawCase: AbstractCase) => {
  const content = getContent(generalCivilLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(generalCivilLawCase),
    productName: getProductData(generalCivilLawCase.name, "label"),
    percentage: getPercentage(generalCivilLawCase),
    extraContent: <ExtraContent litigationCase={generalCivilLawCase} />,
  };
};
